export const getDateFromPosition = (
  segment,
  offset,
  granularity,
  unitCount
) => {
  const ret = segment.getDateFromPosition(
    offset,
    granularity,
    // segment.start,
    segment.toString(),
    unitCount
  );
  // return { ...ret };
  return ret;
};

export function getChildUnitOf(unitName) {
  switch (unitName) {
    case 'minute':
      return 'second';
    case 'hour':
      return 'minute';
    case 'day':
      return 'hour';
    case 'year':
      return 'day';
    case 'decade':
    case 'century':
    case 'millenium':
    case 'myriad':
    case 'epoch':
    case 'aeon':
      return 'year';
    default:
      return '';
  }
}

export function getChildUnitValue(parentUnit, calendar) {
  if (calendar === undefined) {
  }
  const childUnit = getChildUnitOf(parentUnit);
  //do the maths
  //return the bigInt(...).toString();
}

export function getWorldEraPrefixes(world) {
  let ret = {
    before: 'BCE',
    after: 'CE',
  };
  if (world !== undefined && world !== null && world._id !== undefined) {
    const { worldTime } = world;
    if (worldTime) {
      ret.before = worldTime.beforeZeroAbbr || 'BCE';
      ret.after = worldTime.afterZeroAbbr || 'CE';
    }
  }
  return { ...ret };
}
